module.exports = __webpack_public_path__ + "img/pic_6.cef25204.png";